import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Portlet, Row, Col, Form, Button } from '_zari/core'

import * as FormGroups from './formGroups'

import { ValidationSchema } from './validation'

import { DownloadAxiosFile } from 'utils'

import * as InventarioService from 'services/inventario.service'

const EntradasSalidasReporte = () => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      fechaDesde: '',
      fechaHasta: '',
      _idSede: '',
      tipoOperacion: 1
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      __zariContext.loader.open('Descargando reporte de entradas y salidas')
      InventarioService.descargarReporteEntradasSalidas(data)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
          setSubmitting(false)
        })
    },
    [__zariContext]
  )

  return (
    <>
      <Row>
        <Col md={6}>
          <Portlet>
            <Portlet.Header title='REPORTE ENTRADAS SALIDAS' />
            <Portlet.Body>
              <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
                {({ isSubmitting, touched, errors, handleSubmit }) => (
                  <Form>
                    <FormGroups.IdSedeFormGroup fIsSubmitting={isSubmitting} iError={errors._idSede} iTouched={touched._idSede} />
                    <FormGroups.FechaDesdeFormGroup fIsSubmitting={isSubmitting} iError={errors.fechaDesde} iTouched={touched.fechaDesde} />
                    <FormGroups.FechaHastaFormGroup fIsSubmitting={isSubmitting} iError={errors.fechaHasta} iTouched={touched.fechaHasta} />
                    <FormGroups.TipoOperacionFormGroup fIsSubmitting={isSubmitting} iError={errors.tipoOperacion} iTouched={touched.tipoOperacion} />
                    <Row>
                      <Col md={12} className='text-right'>
                        <Button onClick={handleSubmit} disabled={isSubmitting}>
                          Descargar Reporte
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Portlet.Body>
          </Portlet>
        </Col>
      </Row>
    </>
  )
}

export default React.memo(EntradasSalidasReporte)
